import { css } from '@emotion/react'
import { SpacingToken } from '@livechat/design-system-react-components'

export const alertWrapperCss = css`
  margin-bottom: 30px;

  div {
    margin-right: 0;
  }

  h5 {
    margin: 0 0 var(${SpacingToken.Spacing2});
  }
`
